import {FinancialProductType} from '../../api/types/onlineOfferTypes';

const PRODUCT_LABEL_KEYS: Record<FinancialProductType, string> = {
  STANDARD: 'financialProducts.product.standard',
  BALLOON: 'financialProducts.product.balloon',
  LEASING: 'financialProducts.product.leasing',
};

export const getFinancialProductTypeLabelKey = (productType: FinancialProductType) =>
  PRODUCT_LABEL_KEYS[productType];
